// Shared mock data for the Impresa Centro Confiança dashboard.

// Mirrors ThreatCard's three card variants: domain scam, entity/reference scam, suspicious call.
export type SourceType = "domain" | "entity" | "scall";

export type Channel =
  | "Email"
  | "SMS"
  | "WhatsApp"
  | "Telefone"
  | "Web"
  | "Redes sociais";

export type Campaign = {
  id: string;
  title: string;
  // ThreatCard variant
  sourceType: SourceType;
  type: "Phishing" | "Smishing" | "Vishing" | "Marca" | "Rede social" | "Outro";
  // Message fields (DomainThreatCard / EntityThreatCard: messageContent)
  messageContent: string;
  sender: string | null;
  channel: Channel;
  reporter: string;
  createdAt: string; // ISO-8601 for sorting
  date: string;      // Formatted label
  status: "Em análise" | "Mitigada" | "Encerrada" | "Nova";
  severity: "Baixa" | "Média" | "Alta" | "Crítica";
  tags: string[];
  // Domain variant (DomainThreatCard)
  domain?: string | null;
  domainActive?: boolean;
  // Entity/reference variant (EntityThreatCard): Multibanco, IBAN, etc.
  entityReference?: string | null;
  entityReferenceValue?: string | null;
  // sCall variant (SCallThreatCard)
  callType?: string | null;
  description?: string | null;
};

export const CAMPAIGNS: Campaign[] = [
  {
    id: "ICC-2041",
    title: "Email falso do portal RH Impresa",
    sourceType: "domain",
    type: "Phishing",
    messageContent:
      "Caro colaborador, o seu contrato de trabalho foi revisto. Aceda ao portal e confirme os seus dados bancários para processar o pagamento de Abril.",
    sender: "rh@impresa-group.net",
    channel: "Email",
    reporter: "M. Tavares",
    createdAt: "2026-04-14T09:22:00Z",
    date: "14 Abr 2026",
    status: "Em análise",
    severity: "Alta",
    tags: ["Dados bancários", "Portal falso"],
    domain: "impresa-rh-portal.net",
    domainActive: true,
  },
  {
    id: "ICC-2040",
    title: "Conta no X que imita SIC Notícias",
    sourceType: "domain",
    type: "Marca",
    messageContent:
      "EXCLUSIVO SIC: Sorteio especial 30 anos! Partilhe esta publicação e ganhe um iPhone 15 Pro. Apenas hoje!",
    sender: "@SICNoticias_Oficial",
    channel: "Redes sociais",
    reporter: "J. Costa",
    createdAt: "2026-04-13T14:05:00Z",
    date: "13 Abr 2026",
    status: "Mitigada",
    severity: "Média",
    tags: ["Sorteio falso", "Conta falsa"],
    domain: null,
    domainActive: false,
  },
  {
    id: "ICC-2039",
    title: "SMS com referência Multibanco falsa para subscrição Expresso",
    sourceType: "entity",
    type: "Smishing",
    messageContent:
      "A sua subscrição Expresso está em falta. Regularize usando Multibanco: Ent. 19013 Ref. 123 456 789 Valor 9,99€. Válido 24h.",
    sender: "EXPRESSO",
    channel: "SMS",
    reporter: "A. Pereira",
    createdAt: "2026-04-12T11:48:00Z",
    date: "12 Abr 2026",
    status: "Em análise",
    severity: "Crítica",
    tags: ["Multibanco", "Subscrição"],
    entityReference: "Entidade 19013",
    entityReferenceValue: "Referência 123 456 789",
  },
  {
    id: "ICC-2038",
    title: "Página clonada de subscrição do Expresso",
    sourceType: "domain",
    type: "Marca",
    messageContent:
      "Aceda ao Expresso Premium por €0,99 no primeiro mês. Oferta exclusiva para novos subscritores, válida só hoje.",
    sender: null,
    channel: "Web",
    reporter: "R. Mendes",
    createdAt: "2026-04-11T16:30:00Z",
    date: "11 Abr 2026",
    status: "Encerrada",
    severity: "Alta",
    tags: ["Clone de site", "Pagamento"],
    domain: "expresso-subscribe-pt.net",
    domainActive: false,
  },
  {
    id: "ICC-2037",
    title: "WhatsApp urgente em nome de directora geral",
    sourceType: "entity",
    type: "Phishing",
    messageContent:
      "Boa tarde. Preciso de uma transferência urgente e confidencial de 4.200€ para este IBAN. É para fechar um contrato hoje. Obrigada.",
    sender: "+351 912 345 678",
    channel: "WhatsApp",
    reporter: "C. Lopes",
    createdAt: "2026-04-10T10:15:00Z",
    date: "10 Abr 2026",
    status: "Mitigada",
    severity: "Crítica",
    tags: ["CEO Fraud", "Transferência urgente"],
    entityReference: "IBAN",
    entityReferenceValue: "PT50 0035 0413 0000 0000 0000 5",
  },
  {
    id: "ICC-2036",
    title: "Anúncio fraudulento no Facebook usando logo SIC",
    sourceType: "domain",
    type: "Marca",
    messageContent:
      "Concurso SIC 30 anos! Responda a 3 perguntas simples e ganhe €5.000. Só 100 vagas disponíveis. Clique já!",
    sender: "SIC Portugal – Oficial",
    channel: "Redes sociais",
    reporter: "S. Almeida",
    createdAt: "2026-04-09T08:00:00Z",
    date: "09 Abr 2026",
    status: "Em análise",
    severity: "Baixa",
    tags: ["Concurso falso", "Facebook"],
    domain: "sic-concurso-aniversario.xyz",
    domainActive: true,
  },
  {
    id: "ICC-2035",
    title: "Chamada de falso suporte informático da Impresa",
    sourceType: "scall",
    type: "Vishing",
    messageContent:
      "Colaboradora recebeu chamada de suposto técnico de IT afirmando que o seu computador tinha vírus críticos. Solicitou acesso remoto e credenciais de rede.",
    sender: "+351 21 000 1234",
    channel: "Telefone",
    reporter: "P. Vieira",
    createdAt: "2026-04-08T15:40:00Z",
    date: "08 Abr 2026",
    status: "Encerrada",
    severity: "Alta",
    tags: ["Acesso remoto", "Credenciais", "IT"],
    callType: "Vishing – Suporte Técnico",
    description:
      "Colaboradora recebeu chamada de suposto técnico de IT afirmando que o seu computador tinha vírus críticos. Solicitou acesso remoto e credenciais de rede interna.",
  },
  {
    id: "ICC-2034",
    title: "Chamada sobre prémio falso em nome do SIC",
    sourceType: "scall",
    type: "Vishing",
    messageContent:
      "Colaborador recebeu chamada informando que ganhou €2.500 num concurso SIC. Pediu NIF, número de cartão e CVV para processar o prémio.",
    sender: "+351 91 234 5678",
    channel: "Telefone",
    reporter: "I. Sousa",
    createdAt: "2026-04-07T13:20:00Z",
    date: "07 Abr 2026",
    status: "Nova",
    severity: "Média",
    tags: ["Prémio falso", "Dados pessoais", "Cartão"],
    callType: "Vishing – Prémio",
    description:
      "Colaborador reportou chamada a afirmar que ganhou um prémio de €2.500 num concurso SIC, solicitando NIF, número de cartão e CVV para receber o prémio.",
  },
];

export const NEWS = [
  {
    source: "Expresso",
    category: "Investigação",
    title: "Vagas de fraude por SMS atingem nova fase: como reconhecer e travar",
    excerpt:
      "Especialistas analisam o crescimento das campanhas de smishing dirigidas a empresas portuguesas e o papel dos colaboradores na primeira linha de defesa.",
    date: "12 Abr 2026",
    href: "https://expresso.pt",
  },
  {
    source: "SIC Notícias",
    category: "Sociedade",
    title: "Burlas com falsas faturas multiplicam-se: vítimas perdem milhões",
    excerpt:
      "Reportagem mostra como redes coordenadas exploram processos internos das empresas — e o que mudou nos últimos seis meses.",
    date: "10 Abr 2026",
    href: "https://sicnoticias.pt",
  },
  {
    source: "Expresso",
    category: "Economia",
    title: "Cibersegurança nas empresas: investimento sobe 38% em Portugal",
    excerpt:
      "Estudo destaca formação de equipas e cultura de denúncia interna como factores decisivos para reduzir o impacto de ataques.",
    date: "08 Abr 2026",
    href: "https://expresso.pt",
  },
  {
    source: "SIC Notícias",
    category: "País",
    title: "PJ desmantela rede que se fazia passar por departamentos de RH",
    excerpt:
      "Operação revelou centenas de tentativas de obtenção indevida de dados pessoais junto de colaboradores de grandes grupos.",
    date: "05 Abr 2026",
    href: "https://sicnoticias.pt",
  },
  {
    source: "Expresso",
    category: "Tecnologia",
    title: "IA generativa potencia novo tipo de fraude por voz nas empresas",
    excerpt:
      "Casos recentes envolvem clones vocais de executivos a autorizar transferências — recomenda-se confirmação por canal alternativo.",
    date: "03 Abr 2026",
    href: "https://expresso.pt",
  },
  {
    source: "SIC Notícias",
    category: "Justiça",
    title: "Tribunal condena rede que clonava sites de grupos de media",
    excerpt:
      "Decisão marca precedente importante para protecção de marcas editoriais e responsabilização de operadores fraudulentos.",
    date: "01 Abr 2026",
    href: "https://sicnoticias.pt",
  },
];

export const TREND_DATA = [
  { mes: "Out", reportadas: 12, mitigadas: 8 },
  { mes: "Nov", reportadas: 18, mitigadas: 14 },
  { mes: "Dez", reportadas: 22, mitigadas: 19 },
  { mes: "Jan", reportadas: 31, mitigadas: 26 },
  { mes: "Fev", reportadas: 28, mitigadas: 24 },
  { mes: "Mar", reportadas: 36, mitigadas: 30 },
  { mes: "Abr", reportadas: 41, mitigadas: 33 },
];
